import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const SearchBar = ({ onSearch, placeholder = "Search articles, topics, or authors..." }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = async (e) => {
    e?.preventDefault();
    if (!searchTerm?.trim()) return;

    setIsSearching(true);
    
    // Simulate search delay
    setTimeout(() => {
      onSearch(searchTerm);
      setIsSearching(false);
    }, 800);
  };

  const handleClear = () => {
    setSearchTerm('');
    onSearch('');
  };

  return (
    <form onSubmit={handleSearch} className="relative">
      <div className="relative">
        <Input
          type="search"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e?.target?.value)}
          className="pl-12 pr-20"
        />
        
        <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
          <Icon 
            name={isSearching ? "Loader2" : "Search"} 
            size={18} 
            className={`text-muted-foreground ${isSearching ? 'animate-spin' : ''}`}
          />
        </div>
        
        <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center space-x-1">
          {searchTerm && (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="w-8 h-8"
              onClick={handleClear}
            >
              <Icon name="X" size={16} />
            </Button>
          )}
          
          <Button
            type="submit"
            variant="default"
            size="sm"
            disabled={!searchTerm?.trim() || isSearching}
            className="px-3"
          >
            {isSearching ? (
              <Icon name="Loader2" size={16} className="animate-spin" />
            ) : (
              <Icon name="Search" size={16} />
            )}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default SearchBar;